import React from 'react'
import {Trans, useTranslation } from "react-i18next";
import leftarrow from "../../../../assets/images/left-arrow.svg";
import planpricingtooltip from "../../../../assets/images/planpricingtooltip.svg";
import { Footer } from '../../../common/footer/footer';
import PlanJSON from './plans.json';
import { useHistory } from "react-router-dom";
import styles from './plans.module.css';
const PlansJsx = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const {
    bilingPeriod,
    onBilingButtonClick,
    planType,
    onPlanTypeButtonClick,
    // isInstitutionExpet,
    // onInstitutionExpertClick,
    termAndCondition,
    onTermsAndConditionClick,
    onNextButtonClick,
    planDetail
  } = props;

  const getPrice = (name) => {
    const planTypeData = planDetail?.filter(data => data.planName === name);
    let rate = ''
    planTypeData?.[0].subscriptionPlanTypes?.forEach(data => {
      if (data.planType === "quarterly" && bilingPeriod === 'Quaterly Billing')
        rate = data.price
      else if (data.planType === "annually" && bilingPeriod === 'Annual Billing')
        rate = data.price
    })
    return rate;
  }




  return (
    <>
      <section className="expertregistrationnew instituteregistrationnew">
        <div className="container">
          <div className={`${styles.mainloginscreeninner}`}>
            <div className={`${styles.leftsightbackdetails}`}>
              <div className="detailsleft plaindetailsleft  d-flex align-items-center justify-content-center">
                {/* <div className="back_btn" onClick={() => isNormalExpert ? removeId() : history.goBack()}><img src={leftarrow} alt={' '} /></div> */}
                <div className="back_btn" onClick={() => history.goBack()}><img src={leftarrow} alt={' '} /></div>

                
                  <h1> {t("PLANS.TITLE")}  </h1>
                
       
                
                </div>
                <div className="numberingwizerd institutes-numberingwizerd">
                  <ul className="d-flex align-items-center justify-content-center ">
                    <li>1</li>
                    <li className="active">2</li>
                    <li>3</li>
                    
                  </ul>
                </div>
              </div>
            </div>
            <div className={`${styles.formsection}`}>
              <div className="institutelogintext planoutmainsub martop60">
              <p className="text-center pt-3"><Trans>{t("PLANS.FEATURE")}</Trans></p>
              <div className="planbuttonouternew">
                <div className="smtext pt-3">Select the payment frequency</div>
                <div className="planbuttonouternewinner">
                  <button type="button" className={`${bilingPeriod === 'Quaterly Billing' ? 'ctaonebutton' : 'ctatwobutton'} planbutton`} onClick={() => onBilingButtonClick('Quaterly Billing')}>{t("PLANS.QUERTER")}</button>
                  <button type="button" className={`${bilingPeriod === 'Annual Billing' ? 'ctaonebutton' : 'ctatwobutton'} planbutton`} onClick={() => onBilingButtonClick('Annual Billing')}>{t("PLANS.ANNUAL")} <span>{t("PLANS.SAVE")}</span></button>
                </div>
                </div>
            
              </div>
              <div className="mainplan mt-4">
 <h2 className="h3_style">{t("PLANS.Features_to_Boost")}</h2>
              <div className="planwhole">
                <div className="planesall">
                  <div className="row">
                    <div className="col-lg-8 col-sm-8">
                      <div className="planesinner">
                       
                      
                        <ul>
                          {
                            PlanJSON.Plans.map(plans => {
                              return <li>{plans.name} <span className="plantooltip custooltip" ><img src={planpricingtooltip} className="tooltipim" alt={' '} />
                                <div className="tooltipcontent"> {plans.tooltipTitle}</div>
                              </span></li>
                            })
                          }
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-2">
                      <div className={`planesinnerright premium ${planType === 'Premium' ? 'broadtp' : ''}`} onClick={() => onPlanTypeButtonClick('Premium')}>
                        <h2 className="text-center h3_style">{t("PLANS.PREMIUM")}</h2>
                      
                        <ul>
                          {
                            PlanJSON.Plans.map(plans => {
                              return <li>{plans.Premium}</li>
                            })
                          }
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-2">
                      <div className={`planesinnerright elite ${planType === 'Elite' ? 'broadtp' : ''}`} onClick={() => onPlanTypeButtonClick('Elite')}>
                        <h2 className="text-center h3_style">{t("PLANS.ELITE")}</h2>
                      
                        <ul>
                          {
                            PlanJSON.Plans.map(plans => {
                              return <li>{plans.Elite}</li>
                            })
                          }
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
               
                <div className="planesallbottom">
                  <div className="row">
                    <div className="col-lg-8 col-sm-12">
                      <div className="planesinner">
                        <h5 className="h3_style fst-italic">{t("PLANS.SEENFEATURE")}
                          <span>{t("PLANS.SELECTPLAN")}</span></h5>
                          <ul className="d-flex align-items-center pb-5">
                            <li>
                            <h6 className="text-center"> $ {getPrice('Premium')} </h6>
                        <button type="button" class={`${planType === 'Premium' ? 'ctatwobutton' : 'ctaonebutton'}`} onClick={() => onPlanTypeButtonClick('Premium')}>{t("PLANS.PREMIUM")}</button>
                            </li>
                            <li>
                            <h6 className="text-center"> $ {getPrice('Elite')} </h6>
                        <button type="button" class={`${planType === 'Elite' ? 'ctatwobutton' : 'ctaonebutton'}`} onClick={() => onPlanTypeButtonClick('Elite')}>{t("PLANS.ELITE")}</button>
                            </li>
                          </ul>
                          <hr></hr>
                          <div className="planesinner">
                        <h5 className="h3_style fst-italic">{t("PLANS.PAYEXPERT")}
                          <span>{t("PLANS.ADDITIONALFEATURE")}</span></h5>

                      </div>
                      <hr></hr>
                      <div className="planesinnerright">
                        <div className="mb-4 form-check">
                          <input type="checkbox" className="form-check-input" id="termscondition" checked={termAndCondition} onClick={() => onTermsAndConditionClick(!termAndCondition)} />
                          <label className="form-check-label" for="termscondition">{t("PLANS.AGREE")} <a href="/termsCondition" target="_blank" rel="noreferrer" >{t("PLANS.TERMS")}</a></label>
                        </div>
                        <button type="button" disabled={!termAndCondition} className={`${termAndCondition ? 'mainbutton' : 'mainbutton'}`} onClick={() => onNextButtonClick()}>{t("COMMON.CONTINUE")}</button>
                      </div>
                      </div>
                    </div>
                   
                  </div>
                </div>
              
                {/* <div className="planesallbottom">
                  <div className="row">
                    <div className="col-lg-8 col-sm-8">
                   
                    </div>
                    <div className="col-lg-4 col-sm-4">
                      <div className="planesinnerright">
                        <div className="form-check text-center">
                          <label className="container-checkbox" for="premium">
                            <input type="checkbox" id="premium" checked={isInstitutionExpet} onClick={() => onInstitutionExpertClick(!isInstitutionExpet)} />
                            <span className="checkmark"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
              
              
              </div>
            </div>
            </div>
          
         
        </div>
        <Footer/>
      </section>
    </>

  );
};

export default PlansJsx;
